// FeatureTreeWindowItems — the feature-tree ROWS shown in the Feature Tree for
// any resolved window surface (see featureWindowSurface.ts). Each row opens/
// closes its floating window in the viewer (state lives in the shared
// useFeatureWindows store, so the window itself renders over in the
// viewport).
//
// Presentation matches the Files/Folders sidebar (documents page): NO checkbox
// glyph — instead the items NEST under a single top-level parent row named
// after the feature (the resolved surface's `parentLabel`), connected with the
// same ├─ / └─ guide lines as the folder tree. The shared `NestedTreeRows`
// component owns that visual so the JAWS "Features" list can reuse the
// identical pattern.

import { useFeatureWindows } from '@/components/viewer/featureWindow/useFeatureWindows';
import { featureWindowItems } from './featureWindowRegistry';
import { NestedTreeRows, type NestedTreeRow } from './NestedTreeRows';

export function FeatureTreeWindowItems({
  surfaceKey,
  parentLabel,
}: {
  surfaceKey: string;
  parentLabel: string;
}) {
  const { openKey, openFeature, closeFeature } = useFeatureWindows();
  const items = featureWindowItems(surfaceKey);
  if (items.length === 0) return null;

  const rows: NestedTreeRow[] = items.map(({ key, label }) => {
    const active = openKey === key;
    return {
      key,
      label,
      active,
      onClick: () => (active ? closeFeature(key) : openFeature(key)),
    };
  });

  return <NestedTreeRows parentLabel={parentLabel} rows={rows} />;
}
